import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../../slices/auth/login/thunk";

import { useDispatch } from "react-redux";

const Logout = (props: any) => {
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  return <Navigate to="/" />;
};
export default Logout;
